// extracted by mini-css-extract-plugin
module.exports = {"homeWrapper":"cancelOrders_homeWrapper__2o3bn"};